<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Contents - {{content.page_name}}</div>
                </div>
            </div>
            <div class="table-responsive" v-if="contentlist">
                <table class="table table-bordered table-light">
                    <tr v-for="item in contentlist">
                        <th>{{item.content_id.replace(/_/g, ' ')}}</th>
                        <td>{{item.content_value}}</td>
                        <td><button class="btn btn-info btn-sm" @click="editContent(item)" v-tooltip.top-center="tooltips.edit"><i class="fa fa-edit"></i></button></td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    import axios from 'axios';
    export default {
        name: 'ViewContent',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GETSELECTEDCONTENT', this.$route.params.id).then(() =>{
            this.content = this.selectedContent;
            this.contentlist = this.selectedContent.lstDynamicPageContents.filter(x => {
                return x.content_id.toLowerCase().indexOf('meta_tag') > -1
            })
        })

    },
    data () {
        return {
          tooltips: {
            edit: 'Edit Content'
          },
          content: {},
          contentlist: []
        }
    },
    methods: {
        editContent(item){
          let swal = this.$swal;
          let _self = this;
          (async function getFormValues () {
            const {value: formValues} = await swal({
              title: item.content_id.replace(/_/g, ' '),
              html:
              `<textarea id="swal-input1" rows="1" cols="2" class="swal2-textarea"disabled>${item.content_value}</textarea>` +
              `<textarea id="swal-input2" rows="1" class="swal2-textarea" placeholder="Enter New Value" data-value="">${item.content_value}</textarea>`,
              focusConfirm: false,
              width:'60%',
              preConfirm: () => {
                return document.getElementById('swal-input2').value
              },
              showCancelButton: true
            });

            if (!formValues) {
              return false;
            }
            else if(formValues === true){
              _self.showPopup('Error!', 'Please Enter New Value', 'error')
            }
            else{
              let contentUpdate = {
                "pk_dynamic_page_Content_id": item.pk_dynamic_page_Content_id,
                "content_value": formValues
              };
              _self.$store.dispatch('UPDATE_CONTENT', contentUpdate)
                .then((res) => {
                  console.log("UPDATE_CONTENT res : ", res);
                  _self.$store.dispatch('GETSELECTEDCONTENT', _self.$route.params.id).then(() =>{
                    _self.content = _self.selectedContent;
                    _self.contentlist = _self.selectedContent.lstDynamicPageContents.filter(x => {
                      return x.content_id.toLowerCase().indexOf('meta_tag') > -1
                    });
                  });
                  _self.showPopup('Success!', 'Content is successfully updated', 'success', ()=>_self.$router.push(`/admin/tags/view/${_self.$route.params.id}`))

                })
                .catch(err => {
                  _self.showPopup('Error!', 'some thing happen wrong', 'error');
                  console.log("UPDATE_CONTENT API error : ", err);
                })
            }
          })()
        },
        showPopup(title, msg, popupType, cb){
          this.$swal( title, msg, popupType
          ).then(res => {
            cb && cb();
            return res
          })
        }
    },
    computed: {...mapGetters([
        'selectedContent'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
    .swal2-popup .swal2-input{
      line-height: 40px;
    }
    .swal2-popup .swal2-textarea{
      height: 85px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Tags/TagDetails.vue